import React from "react";
const irsadusSemaLarge = require('../../../assets/books/kapaklar/irsadul-sema_600.jpg');
const irsadusSemaMini = require('../../../assets/books/kapaklar/irsadul-sema-300.jpg');
export const IrsadusSemaDescription = (props: any) => {
    return (
        <div className="summary-description">
            <div className="book-image">
                <img 
                src={irsadusSemaLarge} 
                alt="Aşka Meşke Semaya Yolculuk"
                srcSet={`${irsadusSemaMini} 300w, ${irsadusSemaLarge} 600w`}
                sizes={"(max-width: 600px) 300px,  600px"}
                />
            </div>
            <p>
                Sufi yolu, yaşayan bir süreç, bir hayat okuludur. Bu
                okul, insanlara ego zırhından nasıl kurtulacağını ve güneşin
                arkasındaki güneşi nasıl arayacağını göstermektedir.
            </p>

            <p>
                Mevlevilik, tıpkı diğer tarikatlerde olduğu gibi
                manevi bakımdan insanı ham bulunduğu bir noktada
                teslim alır. Onu muhtelif eğitim kademelerinden
                geçirerek, yaşadığı cemiyet içerisinde ve dünya
                üzerindeki vazife ve mesuliyetlerini öğretir.
                Ona sabır, çalışkanlık, insan sevgisi ve engin
                müsamaha gibi günümüzde pek görülmeyen değerli
                hasletler aşılar. İnsanlara hizmetin büyük bir
                ibadet olduğu şuuruna erişmiş, mükemmel insan
                (insan-ı kâmil) yetiştirmek hedefini esas alır.
            </p>

            <p>
                Bilgi ve bu kitapta takdim edilen ve belirtilen
                öğrenmenin yolları, isteğe göre mübadele edilemez
                veya değiştirilemez.
                Bu bilgi mücevheri asırlar
                boyu cilalanmış ve bugüne kadar parlaklığından
                bir şey kaybetmemiştir.
                Sufi yolunda bugün
                özü itibariyle bir şeyler eklenebileceğini söylemek
                ölçüyü kaçırmak olur.
                Böyle bir düşünce her
                türlü gerçek dayanaktan yoksundur. Bu düşünce
                sadece ne kadar az bilgiyle yaklaşıldığını gösterir.
                Sufi yolu, bizim onu tanıdığımız şekliyle, her bir
                insanın ve zamanımız insanlığının sorunlarının çözümü için
                hakiki bir "anahtar"dır.
            </p>

            <p>
                Siz de bu yolun gidilip gidilemeyeceğini denemeye davetlisiniz.
                Halis niyetle birlikte bilgi, teslimiyet ve icraatın yanında sohbet, öğrenmenin
                diğer bir sütunudur.
            </p>

            <p>
                Bizim amacımız, kapalı kaynakları fışkırır hale getirmektir.
                Bunun için tüm gücümüzü bu işe veriyoruz. Ancak ne yaşadıysak, muvazeneli
                ve doğruya sadık kalarak anlatacağız.
            </p>
        </div>
    )
}
export const IrsadusSemaSummaryDescription = (props: any) => {
    return (
        <p>
            Sufi yolu, yaşayan bir süreç, bir hayat okuludur. Bu
            okul, insanlara ego zırhından nasıl kurtulacağını ve güneşin
            arkasındaki güneşi nasıl arayacağını göstermektedir.
            Mevlevilik, tıpkı diğer tarikatlerde olduğu gibi
            manevi bakımdan insanı ham bulunduğu bir noktada
            teslim alır. Onu muhtelif eğitim kademelerinden
            geçirerek, yaşadığı cemiyet içerisinde ve dünya
            üzerindeki vazife ve mesuliyetlerini öğretir.
            Ona sabır, çalışkanlık, insan sevgisi ve engin
            müsamaha gibi günümüzde pek görülmeyen değerli
            hasletler aşılar. İnsanlara hizmetin büyük bir
            ibadet olduğu şuuruna erişmiş, mükemmel insan
            (insan-ı kâmil) yetiştirmek hedefini esas alır.
        </p>
    )
}